import { ArtifactMediaData } from "../../tanstackQuery/queries/artifacts/type";
import { checkRole } from "./base";

const GIVE_SA_PERMISSIONS = true;

export const hasPermissionInterviewWrite = (r: any, interviewID: string, artifact: ArtifactMediaData) => {
    // check if they own the interview
    try {
        if (artifact?.note?.[interviewID] === undefined) {
            return false;
        }
        
        if (r?.user?.userID === artifact?.note?.[interviewID]?.userID) {
            return true;
        }
    }
    catch (e) {
        // console.log(e);
    }

    if (check(r, 'isSystemAdministrator')) {
        return GIVE_SA_PERMISSIONS;
    }

    if (check(r, 'isTeamMember')) {
        return true;
    }

    return false;
}

export const hasPermissionCanvasReOrder = (r: any) => {
    if (check(r, 'isSystemAdministrator')) {
        return GIVE_SA_PERMISSIONS;
    }

    if (check(r, 'isInstructor')) {
        return true;
    }

    if (check(r, 'isTeamMember')) {
        return true;
    }

    return false;
}

export const hasPermissionCanvasWrite = (r: any) => {
    if (check(r, 'isSystemAdministrator')) {
        return GIVE_SA_PERMISSIONS;
    }

    if (check(r, 'isTeamMember')) {
        return true;
    }

    return false;
}

const check = (base: any, role: string) => {
    try {
        if (checkRole(base, role)) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (e) {
        return false;
    }
}
export const hasCanvasWriteAccess = (roleSnapshot: any) => {
    try {
        if (roleSnapshot?.isSystemAdministrator) {
            return GIVE_SA_PERMISSIONS;
        }
        
        if (roleSnapshot?.isTeamMember) {
            return true;
        }
    } catch (e) {
        
    }
    
    return false;
}